import React, { Component } from 'react';

import { isIOS } from 'react-device-detect';
import classes from './StepThree.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';

export default class StepThree extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = { isEmpty: true };
  }

  componentDidMount() {
    if (this.props.age === 0) {
      this.textInput.focus();
    }
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13 && this._validateAge()) {
      this.props.goToStep(4);
    }
  };

  _onChange = (e) => {
    const {
      target: { value },
    } = e;
    this.props.setAge(+value);
    const ageLength = value.length;
    if (ageLength === 2) {
      this.setState({ isEmpty: false });
    }
  };

  _validateAge = () => {
    const { minAge, maxAge, age } = this.props;
    return age >= minAge && age <= maxAge;
  };

  _renderAgeError = () => {
    const { isEmpty } = this.state;
    let ageError = strings.ageError
      .replace('<', this.props.minAge)
      .replace('>', this.props.maxAge);

    return (
      <InputError
        style={{ display: !isEmpty && !this._validateAge() ? 'block' : 'none' }}
      >
        {ageError}
      </InputError>
    );
  };

  render() {
    // console.log('STEP 3 RENDER:', this.props, this.state);
    const { age } = this.props;

    return (
      <div className={classes.StepThree}>
        <div className={classes.InputWrapper}>
          <Input
            setRef={(component) => (this.textInput = component)}
            type={isIOS ? 'text' : 'number'}
            pattern='[0-9]*'
            value={age !== 0 ? age : ''}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onChange={this._onChange}
            label={strings.EnterYourAge}
            onKeyDown={this._handleKeyDown}
            inputLabelStyle={{
              fontSize: '0.8125rem',
              fontWeight: 'var(--font-weight-normal)',
              textAlign: 'left',
              paddingTop: '0',
              width: '100%',
              marginBottom: '0.5rem',
            }}
            placeholder={strings.agePlaceholder}
            maxLength={2}
          />
          {this._renderAgeError()}
        </div>
        <div className={classes.Footer}>
          <Button
            disabled={!this._validateAge()}
            clicked={this.props.goToStep.bind(this, 4)}
          >
            {strings.next}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegisterInner/Steps/StepThree/StepThree.js